import {
	type IdentificationData,
	formatEntryModes,
	getIdentificationTypeLabel,
} from '@/src/core/types/identification.types'
import { cn } from '@/src/core/utils/cn'
import { motion } from 'framer-motion'

export interface IdentificationPanelProperties {
	identificationData: IdentificationData
	customerName?: string
	className?: string
}

const initialMotion = { opacity: 0, y: 20 }
const animateMotion = { opacity: 1, y: 0 }
const exitMotion = { opacity: 0, y: -20 }
const transitionMotion = { duration: 0.3 }

/** Panel displaying identification data after successful card acquisition */
export function IdentificationPanel({
	identificationData,
	customerName,
	className,
}: IdentificationPanelProperties) {
	return (
		<motion.div
			initial={initialMotion}
			animate={animateMotion}
			exit={exitMotion}
			transition={transitionMotion}
			className={cn('rounded-lg border border-[#66d697]/30 bg-[#66d697]/10 p-4', className)}
		>
			<h3 className="mb-3 text-sm font-medium text-white/90">Pass Identified</h3>

			<dl className="space-y-2 text-sm">
				{customerName ? (
					<div className="flex justify-between">
						<dt className="text-white/60">Customer</dt>
						<dd className="font-medium text-white">{customerName}</dd>
					</div>
				) : undefined}

				<div className="flex justify-between">
					<dt className="text-white/60">Pass ID</dt>
					<dd className="font-mono text-white">{identificationData.loyaltyId}</dd>
				</div>

				<div className="flex justify-between">
					<dt className="text-white/60">Read via</dt>
					<dd className="text-white">{formatEntryModes(identificationData.entryMode)}</dd>
				</div>

				<div className="flex justify-between">
					<dt className="text-white/60">ID Type</dt>
					<dd className="text-white">{getIdentificationTypeLabel(identificationData.identificationType)}</dd>
				</div>

				{identificationData.loyaltyBrand ? (
					<div className="flex justify-between">
						<dt className="text-white/60">Program</dt>
						<dd className="text-white">{identificationData.loyaltyBrand}</dd>
					</div>
				) : undefined}
			</dl>
		</motion.div>
	)
}
